<template>
	<div id="app">
		<img class="logo" src="./assets/logo.png" />
		<div class="inputs">
			<div class="input">
				<input id="newPassword" type="password" v-model="newPassword" required />
				<label for="newPassword">New Password</label>
			</div>
			<div class="input">
				<input id="confirmPassword" type="password" v-model="confirmPassword" required />
				<label for="confirmPassword">Confirm Password</label>
			</div>
		</div>
		<div class="reset-button">
			<button v-if="validToken && !resetSuccessful" type="submit" v-on:click="resetPassword()">Reset Password</button>
			<button v-if="!validToken || resetSuccessful">Reset Password</button>
		</div>
		<div v-if="!validToken && !resetSuccessful" class="invalid-token-overlay">
			<div class="invalid-token">
				<h1>Error</h1>
				<div class="error-text">
					Reset password token is invalid or has expired.<br />
					Please try requesting a password reset from the app again.
				</div>
				<button class="invalid-token-button" type="submit" v-on:click="closeWindow()">Exit</button>
			</div>
		</div>
		<div v-if="resetSuccessful" class="reset-success-overlay">
			<div class="reset-success">
				<h1>Password Reset!</h1>
				<div class="success-text">
					You can now log in with your new password on the<br />
					Perfect Portions App.
				</div>
				<button class="reset-success-button" type="submit" v-on:click="closeWindow()">Exit</button>
			</div>
		</div>
	</div>
</div>
</template>

<script>
export default {
	name: 'app',
	data () {
		return {
			newPassword: '',
			confirmPassword: '',
			api: 'https://api.perfectportions.greatergoods.com/v1/account/reset-password',
			token: window.location.pathname.split('/').slice(-1)[0],
			validToken: true,
			resetSuccessful: false
		}
	},
	created: function () {
		this.$http.post(`${this.api}/check`, { token: this.token }).then((res) => {
			this.validToken = res.body.isValid;
		}, (err) => {
			this.validToken = false;
		});
	},
	methods: {
		closeWindow: function() {
			window.close();
		},
		resetPassword: function() {
			const data = {
				token: this.token,
				password: this.newPassword
			};
			this.$http.post(`${this.api}/submit`, data).then((res) => {
				if (res.status === 204) {
					this.resetSuccessful = true;
				}
			}, (err) => {
				this.validToken = false;
			});
		}
	}
};
</script>

<style>
body {
	background-color: #00C18B;
}

* {
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
}

#app {
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	text-align: center;
	margin-top: 60px;
	min-width: 300px;
}

.logo {
	width: 25%;
}

.inputs {
	margin-top: 100px;
}

.input {
	position: relative;
	margin: 25px auto 0;
	width: 20%
}

input {
	background-color: transparent;
	border: none;
	outline: none;
	width: 100%;
	height: 1.75rem;
	font-size: 1.25rem;
	padding-top: 1.5rem;
	border-bottom: 2px solid #eee;
	color: #f4f4f4;
	transition: border-bottom 0.2s;
}

input:focus {
	border-bottom: 2px solid #fff;
	transition: border-bottom 0.2s;
}

input:valid {
	border-bottom: 2px solid #fff;
	transition: border-bottom 0.2s;
}

label {
	position: absolute;
	left: 0;
	top: 1.5rem;
	color: #eee;
	font-size: 1.25rem;
	transition: top 0.2s, font-size 0.2s, color 0.2s;
	cursor: text;
}

input:focus + label {
	top: 0;
	font-size: 1rem;
	color: #fff;
	transition: top 0.2s, font-size 0.2s, color 0.2s;
}

input:valid + label {
	top: 0;
	font-size: 1rem;
	color: #fff;
	transition: top 0.2s, font-size 0.2s, color 0.2s;
}

.reset-button {
	margin-top: 3rem;
}

button {
	width: 20%;
	height: 40px;
	border: none;
	background-color: #fff;
	border-radius: 3px;
	font-size: 1rem;
	outline: none;
	cursor: pointer;
}

button:active {
	background-color: #eee;
}

.invalid-token-overlay, .reset-success-overlay {
	position: absolute;
	top: 0;
	left: 0;
	background-color: rgba(0, 0, 0, 0.5);
	height: 100vh;
	width: 100vw;
}

.invalid-token, .reset-success {
	position: absolute;
	top: 250px;
	left: calc(50% - 250px);
	background-color: #fff;
	width: 500px;
	border-radius: 5px;
	transition: top 1s;
}

.invalid-token-button, .reset-success-button {
	margin: 20px 0;
	font-weight: 400;
}

@media (max-width: 1200px) {
	.logo {
		width: 40%;
	}

	.input, button {
		width: 26%;
	}
}

@media (max-width: 1000px) {
	.logo {
		width: 50%;
	}

	.input, button {
		width: 33%;
	}
}

@media (max-width: 700px) {
	.logo, .input, button {
		width: 75%;
	}
}
</style>



// WEBPACK FOOTER //
// src/App.vue?226f41ee